import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import Layout from './common/Layout';
import Main from './pages/Main';
import { TranslationProvider } from './contexts/TranslationContext';

const router = createBrowserRouter([
  {
    path: '/:lang',
    element: <Layout><Main /></Layout>,
  },
  {
    path: '/',
    element: <Navigate to="/ka" replace />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
);